module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[18]505.b167eb7.woff2";